import { MODULE_NAME } from './const';
import {
	SET_ACCOUNT_EMAIL_DOMAINS,
	ADD_ACCOUNT_EMAIL_DOMAIN,
	UPDATE_ACCOUNT_EMAIL_DOMAIN,
	SET_ACCOUNT_REPLY_TO_EMAILS,
	SET_ACCOUNT_UNSUBSCRIBE_CONTACT_EMAILS,
} from './mutations';
import StoreModuleService from '../StoreModuleService';
import api from '@/api';
import { activeAccountId } from '@/store/modules/account/getters';
import { arrayToObject } from '@/utils/helpers';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const fetchAccEmailDomains = buildActionObject('fetchAccEmailDomains');
export const setAccEmailDomains = buildActionObject('setAccEmailDomains');
export const addAccEmailDomain = buildActionObject('addAccEmailDomain');
export const updateAccEmailDomain = buildActionObject('updateAccEmailDomain');
export const verifyDkim = buildActionObject('verifyDkim');
export const sendVerifyEmail = buildActionObject('sendVerifyEmail');
export const verifyReplyToEmailOtp = buildActionObject('verifyReplyToEmailOtp');
export const verifyUnsubscribeContactEmailOtp = buildActionObject('verifyUnsubscribeContactEmailOtp');
export const fetchReplyToEmails = buildActionObject('fetchReplyToEmails');
export const deleteReplyToEmails = buildActionObject('deleteReplyToEmails');
export const fetchUnsubscribeContactEmails = buildActionObject('fetchUnsubscribeContactEmails');
export const deleteUnsubscribeContactEmails = buildActionObject('deleteUnsubscribeContactEmails');
export const deleteEmailDomain = buildActionObject('deleteEmailDomain');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchAccEmailDomains.action]({ dispatch }) {
		const accEmailDomains = await api.listAccountEmailDomains();
		const accEmailDomainsObj = arrayToObject(accEmailDomains);
		await dispatch(setAccEmailDomains.action, { accEmailDomains: accEmailDomainsObj });
	},
	[setAccEmailDomains.action]({ commit }, { accEmailDomains }) {
		commit(SET_ACCOUNT_EMAIL_DOMAINS, accEmailDomains);
	},
	async [addAccEmailDomain.action]({ commit }, payload) {
		const resp = await api.createAccountEmailDomain(payload);
		commit(ADD_ACCOUNT_EMAIL_DOMAIN, resp);
		return resp;
	},
	async [verifyDkim.action]({ commit }, accEmailDomainId) {
		const updatedAccEmailDomain = await api.verifyDkim(accEmailDomainId);
		commit(UPDATE_ACCOUNT_EMAIL_DOMAIN, updatedAccEmailDomain);
		return updatedAccEmailDomain;
	},
	async [sendVerifyEmail.action](_, email) {
		await api.sendVerifyEmail(email);
	},
	async [verifyReplyToEmailOtp.action]({ rootGetters }, otp) {
		return await api.verifyReplyToEmailOtp(rootGetters[activeAccountId.fullPath], otp);
	},
	async [verifyUnsubscribeContactEmailOtp.action]({ rootGetters }, otp) {
		return await api.verifyUnsubscribeContactEmailOtp(rootGetters[activeAccountId.fullPath], otp);
	},
	async [fetchReplyToEmails.action]({ commit }) {
		const response = await api.listReplyToEmails();
		commit(SET_ACCOUNT_REPLY_TO_EMAILS, response.reply_to);
		return response.reply_to;
	},
	async [deleteReplyToEmails.action]({ commit }, email) {
		const response = await api.deleteReplyToEmail(email);
		commit(SET_ACCOUNT_REPLY_TO_EMAILS, response.reply_to);
		return response.reply_to;
	},
	async [fetchUnsubscribeContactEmails.action]({ commit, rootGetters }) {
		const response = await api.listUnsubscribeContactEmails(rootGetters[activeAccountId.fullPath]);
		commit(SET_ACCOUNT_UNSUBSCRIBE_CONTACT_EMAILS, response.unsubscribe_emails);
		return response.reply_to;
	},
	async [deleteUnsubscribeContactEmails.action]({ commit, rootGetters }, email) {
		const response = await api.deleteUnsubscribeContactEmail(rootGetters[activeAccountId.fullPath], email);
		commit(SET_ACCOUNT_UNSUBSCRIBE_CONTACT_EMAILS, response.unsubscribe_emails);
		return response.reply_to;
	},
	async [deleteEmailDomain.action]({ dispatch }, accEmailDomainId) {
		await api.deleteAccountEmailDomain(accEmailDomainId);
		dispatch(fetchAccEmailDomains.action);
	},
	async [updateAccEmailDomain.action]({ dispatch }, accEmailDomain) {
		const id = accEmailDomain.id;
		delete accEmailDomain.id;
		await api.updateAccountEmailDomain(id, accEmailDomain);
		dispatch(fetchAccEmailDomains.action);
	},
};

export default actions;
